import { render, staticRenderFns } from "./OrderActionBillAmount.vue?vue&type=template&id=31a75e1c&"
import script from "./OrderActionBillAmount.vue?vue&type=script&lang=ts&"
export * from "./OrderActionBillAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports